import styled from '@emotion/styled'

import { mediaDown } from '@/styles/media'
import { colors } from '@/styles/theme'

export const Wrapper = styled.div`
  display: flex;
  padding: 16px 24px;
  justify-content: space-between;
  align-items: center;
  border-radius: 28px;
  background: #fff;
  box-shadow: 0px 4px 24px 0px rgba(9, 55, 105, 0.08);
  position: relative;
`

export const SelectedDistance = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  width: 100%;
`

export const Placeholder = styled.span`
  color: #c1c5c9;
  font-family: 'Nunito';
  font-size: 12px;
  font-weight: 600;

  @media (min-width: 769px) {
    font-size: 16px;
    color: #c1c5c9;
  }

  @media (min-width: 1024px) {
    font-size: 18px;
  }
`

export const DropdownIcon = styled.img<{ isOpen: boolean }>`
  transition: transform 0.3s;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`

export const DropdownList = styled.ul<{ round?: boolean }>`
  list-style-type: none;
  padding: 0;
  margin: 8px 0 0 0;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  border-radius: ${({ round }) => (round ? '32px' : '8px')};
  background: #fff;
  box-shadow: 0px 4px 24px 0px rgba(9, 55, 105, 0.08);
  z-index: 10;
`

export const DropdownOption = styled.li`
  padding: 12px 16px;
  cursor: pointer;
  &:hover {
    background-color: rgba(9, 55, 105, 0.1);
  }
`

export const SelectedItemText = styled.p`
  color: ${colors.twilightBlue};
  font-family: 'Nunito';
  font-size: 18px;
  font-weight: 600;

  ${mediaDown('md')} {
    font-size: 16px;
  }
`

export const SortdownOption = styled.li<{ selected?: boolean }>`
  padding: 12px 34px;
  cursor: pointer;
  color: ${({ selected }) =>
    selected ? `${colors.twilightBlue}` : `${colors.seaBlue}`};
  font-family: 'Nunito';
  font-size: 18px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  &:hover {
    color: ${colors.twilightBlue};
  }

  ${mediaDown('md')} {
    font-size: 16px;
  }
`
